import { ICharge } from '../interfaces/ICharge';
import ICheckoutChargeResponse from '../interfaces/ICheckoutChargeResponse';
import IPaymentGateway from '../interfaces/IPaymentGateway';
import IStripeChargeResponse from '../interfaces/IStripeChargeResponse';
import errorHelpers from '../helpers/errors';
import { PaymentIntent } from '@stripe/stripe-js';

export interface IStripePaymentParams {
    siteId: number;
    invoiceId: number;
    charge: ICharge;
    name: string | null;
    emailAddress: string | null;
    bookingId: number | null;
    currencyTypeId: number | undefined;
    purchaseType: number;
}

class Payments {
    static GetPaymentGateways = (siteId: number, purchaseType: number, currencyTypeId?:number): Promise<Array<IPaymentGateway>> => {
        let url = `payments/gateways/${siteId}?purchaseType=${purchaseType}`;

        //add currency type id if provided, should result in the correct global payment gateway for that currency being returned for global gift vouchers
        if (currencyTypeId) {
            url = `${url}&currencyTypeId=${currencyTypeId}`;
        }
        
        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<Array<IPaymentGateway>>);
    };

   

    static StripePayment = (
        props: IStripePaymentParams,
        signal?: AbortSignal
    ): Promise<IStripeChargeResponse> => {
        const paymentRequest = {
            emailAddress: props.emailAddress,
            name: props.name,
            charge: props.charge,
            bookingId: props.bookingId,
        };

        let url = `payments/${props.siteId}/${props.invoiceId}/pay/stripe?purchaseType=${props.purchaseType}`;
        if (props.currencyTypeId) {
            url = `${url}&currencyTypeId=${props.currencyTypeId}`;
        }

        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentRequest),
            signal
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IStripeChargeResponse>);
    };

    static StripeConfirmation = (
        paymentIntent: PaymentIntent,
        siteId: number,
        invoiceId: number,
        currencyTypeId: number | undefined
    ): Promise<IStripeChargeResponse> => {
        const paymentRequest = {
            paymentIntentId: paymentIntent.id,
        };

        let url = `payments/${siteId}/${invoiceId}/pay/stripe/confirm`;
        if (currencyTypeId) {
            url = `${url}?currencyTypeId=${currencyTypeId}`;
        }

        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentRequest),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IStripeChargeResponse>);
    };

    static StripePaymentStatus = (
        paymentIntent: string,
        siteId: number,
        invoiceId: number,
        currencyTypeId: number | undefined,
        purchaseType: number| undefined
    ): Promise<IStripeChargeResponse> => {
        let url = `payments/${siteId}/${invoiceId}/pay/stripe/${paymentIntent}`;
        if (currencyTypeId && purchaseType) {
            url = `${url}?currencyTypeId=${currencyTypeId}&purchaseType=${purchaseType}`;
        }


        //todo DO WE NEED THE CURRENCY TYPE ID JUST TO GET THE STATUS OF THE PAYMENT??

        console.log(`stripe check status paymentIntent ${paymentIntent}`);

        return fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IStripeChargeResponse>);
    };

    static CheckoutPayment = (
        charge: ICharge,
        token: string,
        emailAddress: string,
        name: string,
        phoneNumber: string,
        siteId: number,
        invoiceId: number,
        adBlockDetected: boolean
    ): Promise<ICheckoutChargeResponse> => {
        const paymentRequest = {
            cardToken: token,
            emailAddress: emailAddress,
            charge: charge,
            name: name,
            phoneNumber: phoneNumber,
            adBlockDetected: adBlockDetected,
            newPaymentSystem: true,
        };

        return fetch(`payments/${siteId}/${invoiceId}/pay/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentRequest),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<ICheckoutChargeResponse>);
    };
}

export default Payments;
